var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-sm btn-danger",attrs:{"href":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.destroy.apply(null, arguments)}}},[_c('span',{staticClass:"fa fa-trash"})])
}
var staticRenderFns = []

export { render, staticRenderFns }